// extracted by mini-css-extract-plugin
module.exports = {"post":"PostTile_post__1VftR","avatar":"PostTile_avatar__23ZZR","order":"PostTile_order__36ChI","orderSum":"PostTile_orderSum__3a1fo"};